<footer class="tk-footer__wrapper">
  <section class="tk-footer__section">
    <label class="tk-label"></label>
  </section>
</footer>
